import { Globe, Mail } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useTranslation } from 'react-i18next';

/**
 * Full-page geo-restriction screen shown when the visitor's IP
 * resolves to a country in the BLOCKED_COUNTRIES platform setting.
 *
 * To add/remove countries: update the BLOCKED_COUNTRIES row in
 * the platform_settings table (Supabase dashboard or admin panel).
 * No code change required.
 */
export function GeoBlockedPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-stone-950 to-stone-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Icon */}
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-amber-500/10 border border-amber-500/20">
          <Globe className="h-10 w-10 text-amber-500" />
        </div>

        {/* Heading */}
        <div className="space-y-3">
          <h1 className="text-2xl font-bold text-stone-100 tracking-tight">
            {t('geoBlock.title', 'Service Unavailable in Your Region')}
          </h1>
          <p className="text-stone-400 leading-relaxed text-sm">
            {t(
              'geoBlock.body',
              'Candle is not currently available in your country. We are working to expand access over time.',
            )}
          </p>
        </div>

        {/* Divider */}
        <div className="mx-auto w-12 h-px bg-amber-500/25" />

        {/* Support link */}
        <Button
          variant="outline"
          className="border-amber-500/30 bg-amber-500/8 text-amber-400 hover:bg-amber-500/15 hover:border-amber-500/50 hover:text-amber-300 gap-2 rounded-full"
          asChild
        >
          <a href="mailto:support@mycandle.co">
            <Mail className="h-4 w-4" />
            {t('geoBlock.contact', 'Contact Support')}
          </a>
        </Button>
      </div>
    </div>
  );
}
